function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { useOverrides } from "../../hooks/useOverrides";
import { StraightFace } from "../../Icons";

import {
ContactButton as ContactButtonComponent,
Container as ContainerComponent,
Title as TitleComponent,
Message as MessageComponent } from "./ErrorScreen.styles";


const defaultComponents = {
  ContactButton: ContactButtonComponent,
  Container: ContainerComponent,
  Title: TitleComponent,
  Message: MessageComponent };











export const ErrorScreen = ({
  className = '',
  title,
  message,
  contactButtonText,
  onContactButtonClick = () => void 0,
  overrides = {} }) =>
{
  const theme = useContext(ThemeContext);

  const {
    Container: { component: Container, props: containerProps },
    Title: { component: Title, props: titleProps },
    Message: { component: Message, props: messageProps },
    ContactButton: { component: ContactButton, props: contactButtonProps } } =
  useOverrides(defaultComponents, overrides);

  return /*#__PURE__*/(
    React.createElement(Container, _extends({ className: className }, containerProps), /*#__PURE__*/
    React.createElement(StraightFace, { color: theme.colors['Level 4'] }), /*#__PURE__*/

    React.createElement(Title, titleProps, title), /*#__PURE__*/
    React.createElement(Message, messageProps, message), /*#__PURE__*/
    React.createElement(ContactButton, _extends({ onClick: onContactButtonClick }, contactButtonProps),
    contactButtonText)));



};